//#region Shared Badge Position Enum

export enum SharedBadgePositionEnum {
  BottomLeft = 'bottom-left',
  BottomMiddle = 'bottom-middle',
  BottomRight = 'bottom-right',
  MiddleLeft = 'middle-left',
  MiddleMiddle = 'middle-middle',
  MiddleRight = 'middle-right',
  TopLeft = 'top-left',
  TopMiddle = 'top-middle',
  TopRight = 'top-right',
}

//endregion
